import { AutogenLayoutOffPayeeList } from "./autogen/AutogenLayoutOffPayeeList";
import { UrlUtil } from "@mcleod/core";

export class OffPayeeList extends AutogenLayoutOffPayeeList {
    onLoad(): void | Promise<void> {
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search);
        if (urlProp != null && urlProp.ids != null) {
            this.mainDataSource.search({ ids: urlProp.ids });
        }
    }
}
